import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import styles from './ContactUs.module.css';
import telegram from '../../../images/telegram.png';
import phone from '../../../images/phone.png';

import { getTranslation, normalizeLang } from '../../../helpers/translation';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const { lang: rawLang } = useParams();
  const lang = normalizeLang(rawLang);
  const t = useMemo(() => getTranslation(lang), [lang]);

  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const htmlMessage = `
      <div>
        <p><b>Name:</b> ${formData.name}</p>
        <p><b>Email:</b> ${formData.email}</p>
        <p><b>Phone:</b> ${formData.phone}</p>
        <p><b>Message:</b> ${formData.message}</p>
      </div>`;

    try {
      await axios.post(
        'https://qf619qasm2.execute-api.us-east-2.amazonaws.com/dev/sendMail',
        {
          recipient: 'dreamonelove.official@gmail.com',
          topic: 'New message from Artemida Studio',
          message: htmlMessage,
        },
      );
      setFormData({ name: '', phone: '', email: '', message: '' });
    } catch (err) {
      console.error('Send failed:', err);
    }
  };

  return (
    <div className={styles.contactContainer} id="contact">
      <h1>{t.contactSection.title}</h1>

      <div className={styles.contactFormContainer}>
        <div className={styles.contactInfo}>
          <p>Warsaw, Poland</p>
          <p>Rolna str. 191/193</p>
          <p>02-729</p>

          <p>
            <a href="tel:+48500815139" className={styles.link}>
              +48 500 815 139
            </a>
          </p>

          <p>
            <a
              href="mailto:dreamonelove.official@gmail.com"
              className={styles.link}
            >
              dreamonelove.official@gmail.com
            </a>
          </p>

          <div className={styles.icons}>
            <a
              href="https://t.me/ikharatin"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <img
                src={telegram}
                alt=""
                loading="lazy"
                className={styles.icon}
              />
            </a>

            <a href="tel:+48500815139" aria-label="Phone">
              <img src={phone} alt="" loading="lazy" className={styles.icon} />
            </a>
          </div>
        </div>

        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <div className={styles.gradientContainer}>
            <input
              type="text"
              name="name"
              placeholder={t.contactSection.placeholderName}
              aria-label={t.contactSection.placeholderName}
              value={formData.name}
              onChange={handleChange}
              required
              className={styles.input}
              autoComplete="name"
            />
          </div>

          <div className={styles.gradientContainer}>
            <input
              type="tel"
              name="phone"
              placeholder={t.contactSection.placeholderPhone}
              aria-label={t.contactSection.placeholderPhone}
              value={formData.phone}
              onChange={handleChange}
              required
              className={styles.input}
              autoComplete="tel"
            />
          </div>

          <div className={styles.gradientContainer}>
            <input
              type="email"
              name="email"
              placeholder={t.contactSection.placeholderEmail}
              aria-label={t.contactSection.placeholderEmail}
              value={formData.email}
              onChange={handleChange}
              required
              className={styles.input}
              autoComplete="email"
            />
          </div>

          <div className={styles.gradientContainer}>
            <textarea
              name="message"
              placeholder={t.contactSection.placeholderMessage}
              aria-label={t.contactSection.placeholderMessage}
              value={formData.message}
              onChange={handleChange}
              required
              className={styles.textarea}
            />
          </div>

          <button type="submit" className={styles.contactUs}>
            {t.contactSection.sendButton}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
